<app-header></app-header>
<main class="flex-shrink-0">
<app-root></app-root>
</main>
<app-footer></app-footer>

